angular.module('wbControllers').controller('UserDashboardController',
  ['$scope', '$rootScope', '$resource', '$q', 'users', 'CurrentUserPartnerChannel', 'locale', 'AccountApplication', 'FinancialPlan', 'Dashboard', 'History', '$routeParams', '$window', 'SendEbookOfferCodeEmail',
    function ($scope, $rootScope, $resource, $q, users, CurrentUserPartnerChannel, locale, AccountApplication, FinancialPlan, Dashboard, History, $routeParams, $window, SendEbookOfferCodeEmail) {
      this.accountApplications = AccountApplication.query($routeParams);
      this.financialPlans = FinancialPlan.query($routeParams);
      this.hasExternalAdvisor = $window.currentUser.hasExternalAdvisor;

      this.accounts = [];
      this.hisaAccounts = [];
      this.allAccounts = [];
      this.userHasAccounts = false;
      this.canCreateHISA = false;
      this.hisaRate = null;
      this.homeCountry = null;
      this.inRestrictedCountry = false;
      this.isManzilClient = false;
      this.restrictedCountryTooltipPath = (locale.isFrench() ? 'https://help.cidirectinvesting.com/fr_FR/14782-non-residents/je-suis-un-expatrie-vivant-a-l-exterieur-du-canada-puis-je-investir-avec-wealthbar' : 'https://help.cidirectinvesting.com/en_US/non-residents/im-an-expatriate-who-lives-outside-of-canada-can-i-invest-with-wealthbar');
      this.blockManzilClientTooltipPath = (locale.isFrench() ? 'https://help.cidirectinvesting.com/fr_FR/transfer-of-your-ci-direct-investing-account-to-onevest' : 'https://help.cidirectinvesting.com/halal-investing-manzil/transfer-of-your-ci-direct-investing-account-to-onevest');
      this.isFrench = locale.isFrench();

      this.accountApplicationPath = $window.process.env.ACCOUNT_APPLICATION_PATH;
      this.view = 'performance';

      // Get and assign the various config variables from config#show
      const configVariables = $resource('/api/config', {});
      configVariables.get().$promise.then((configs) => {
        this.hisaRate = configs.rates.hisa_rate;
      });

      const clientProfile = $resource('/api/clients/:id');
      clientProfile.get({id: $window.currentUser.id}).$promise.then((clientProfileProperties) => {
        this.homeCountry = clientProfileProperties.address?.country;
      }).then(() => {
        if (this.homeCountry) {
          const restrictedCountries = $resource('/api/restricted-countries');
          restrictedCountries.query().$promise.then((restrictedCountriesArray) => {
            this.inRestrictedCountry = restrictedCountriesArray.includes(this.homeCountry);
          });
        }
      });

      CurrentUserPartnerChannel.get((data) => {
        this.isManzilClient = data.partnerChannel === 'manzil';
      });

      this.openAccountHandler = () => {
        if (!this.inRestrictedCountry && !this.isManzilClient) {
          $window.location.href = this.accountApplicationPath;
        } else if (this.isManzilClient) {
          $scope.blockManzilClientDialog.show();
        } else {
          $scope.restrictedCountryDialog.show();
        }
      };

      this.openInvestmentHandler = () => {
        if (!this.inRestrictedCountry && !this.isManzilClient) {
          $window.location.href = '/account-applications/new';
        } else if (this.isManzilClient) {
          $scope.blockManzilClientDialog.show();
        } else {
          $scope.restrictedCountryDialog.show();
        }
      };

      this.openHisaHandler = () => {
        if (!this.inRestrictedCountry && !this.isManzilClient) {
          $window.location.href = '/app/client/account_application/hisa';
        } else if (this.isManzilClient) {
          $scope.blockManzilClientDialog.show();
        } else {
          $scope.restrictedCountryDialog.show();
        }
      };

      this.replaceMessageWithHyperlink = (message, searchRegex, englishLink, frenchLink) => {
        const regex = new RegExp(searchRegex);
        const hyperlink = this.isFrench ? frenchLink : englishLink;

        const newMessage = message.replace(regex, `<a href="${hyperlink}" target="_blank" rel="noopener noreferrer">$1</a>`);

        return newMessage;
      }

      // TODO: Rewrite this whole thing to use a single endpoint
      this.inceptionData = Dashboard.get($routeParams, (inceptionData) => {
        if (inceptionData === undefined) { return; }
        this.accountIds = _.map(inceptionData.accounts, 'id');
        this.user = inceptionData.user;
        this.setCanCreateHISA(inceptionData.canCreateHisa);
        this.parseAndSetAccounts(inceptionData.accounts);
        this.taskReminders = inceptionData.taskReminders;
        this.holdings = [];
        this.pieChartData = inceptionData.assetClassAllocation;
        if (!_.some(inceptionData.positions)) { return; }
        for (const position of inceptionData.positions) {
          const existingPosition = _.find(this.holdings, { symbol: position.symbol });
          if (existingPosition) {
            existingPosition.amount += parseFloat(position.quantity);
          } else {
            this.holdings.push({
              symbol: position.symbol,
              description: position.description,
              assetClass: position.assetClass,
              amount: parseFloat(position.quantity),
            });
          }
        }

        this.holdings = _.orderBy(this.holdings, 'amount', false);
      });

      $scope.$watch('ctrl.range', (range) => {
        if (range == null) { return; }
        this.loaded = false;

        // This would send a datetime with a timezone (which gets lost when we catch the response
        // in the API) and really we need it to just send the date relevant to the client's timezone
        // because the API is interpreting the datetime as UTC & its giving an artificial offset which
        // can make the start/end dates used to make the ROR period inconsistent depending on time of day.

        for (let key in range) {
          if (key === 'startDate' || key === 'endDate') {
            // mutate datetime with timezone to date as of user's local browser.
            range[key] = moment(range[key]).format('YYYY-MM-DD')
          }
        }

        this.hideDetails();
        Dashboard.get(_.merge($routeParams, range), (d) => {
          this.dashboard = d;
          this.loaded = true;
        });

        History.query(_.merge($routeParams, range, { cad: true }), (history) => {
          history.forEach(d => d.date = moment(d.date));
          this.history = history;
        });
      });

      this.hasPlansEnabled = $window.process ? $window.process.env.FEATURE_FINANCIAL_PLANS !== 'false' : true;
      this.hasToolsEnabled = $window.process ? $window.process.env.FEATURE_TOOLS !== 'false' : true;
      this.hasBlogEnabled = $window.process ? $window.process.env.FEATURE_BLOG !== 'false' : true;
      this.getBrandName = () => {
        let name = 'CI Direct Investing';
        if ($window.process && $window.process.env && $window.process.env.WHITELABEL_FULL_NAME) {
          name = $window.process.env.WHITELABEL_FULL_NAME;
        }
        return name;
      };

      this.showROR = balance => balance > 0;

      this.hasFundedAccount = () => {
        if (this.accounts && this.accounts.length > 0) {
          let total = 0;
          this.accounts.forEach((acc) => {
            if (acc.endingBalance) { total += acc.endingBalance; }
          });

          return total > 0;
        } else {
          return false;
        }
      }

      // Check if wealthie client initial onboarding
      CurrentUserPartnerChannel.get((data) => {
        this.isWealthieClientInitialOnboarding = data.partnerChannel === 'wealthie' && !$window.currentUser.hasActiveAccounts;
      });

      this.displayHISASection = () => (this.hisaAccounts.length || this.canCreateHISA) && !this.isWealthieClientInitialOnboarding;

      this.setCanCreateHISA = (canCreateHisa) => {
        if (!canCreateHisa || canCreateHisa.error) {
          this.canCreateHISA = false;
        } else {
          this.canCreateHISA = true;
        }
      }

      this.accountApplications.$promise.then(response => {
        this.applicationPending = !!response.find(app => app.status === 'incomplete')
      })

      this.sendEmailConfirmation = () => {
        this.emailConfirmationSuccess = false;
        this.emailConfirmationFailed = false;
        return users.sendEmailConfirmation()
      .then(() => (this.emailConfirmationSuccess = true))
      .catch(() => (this.emailConfirmationFailed = true));
      };

      this.cancelApplication = (app) => {
        if (app) {
          AccountApplication.delete({ id: app.id }, () => {
            _.remove(this.accountApplications, a => a.id === app.id);
          });
        }
      };

      this.parseAndSetAccounts = (accounts) => {
        if (!accounts || accounts.length === 0) { return false; };

        this.accounts = this.parseNonHISA(accounts);
        if (this.accounts.length > 0) { this.userHasAccounts = true; };

        this.hisaAccounts = this.parseHISA(accounts);
        this.allAccounts = accounts;
      };

      this.parseNonHISA = (accounts) => {
        return accounts.filter((acc) => { return acc.accountType !== 'hisa'; });
      };

      this.parseHISA = (accounts) => {
        return accounts.filter((acc) => { return acc.accountType === 'hisa'; });
      };

  // Chart Details Related
      $scope.$on('chartClicked', (e, details) => {
        this.chartDetails = details;
        this.selectedTab = 'details';
      });

      $scope.$on('overlayHidden', (e) => {
        this.chartDetails = undefined;
        this.selectedTab = 'performance';
      });

      let hidingDetails = false;
      this.showDetails = () => {
        if (!hidingDetails) { this.selectedTab = 'details'; }
        return hidingDetails = false;
      };

      this.hideDetails = () => {
        this.chartDetails = undefined;
        this.selectedTab = 'performance';
        hidingDetails = true;
        $scope.$broadcast('detailsHidden');
      };

      $scope.handleSendOfferCodeEmail = () => {
        const currentUser = users.getCurrentUser();
        // exclude any staff user click the button
        if (!Object.values(currentUser.roles).includes("staff")) {
          SendEbookOfferCodeEmail.sendEbookOfferCodeEmail({ email: currentUser.email, id: currentUser.id});
          $scope.closeEmailSentDialog.show();
        }
      };

      this.closeEmailSentDialog = () => {
        $scope.closeEmailSentDialog.hide()
        $window.location.reload();
      };

      return this;
    },
  ]);
